var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-provider-buttons",class:{
    'auth-provider-buttons--small': _vm.showSmallLoginButtons,
    'auth-provider-buttons__no-buttons': _vm.loginButtons.length === 0,
    'auth-provider-buttons__no-buttons--hide':
      _vm.loginButtons.length === 0 && _vm.hideIfNoButtons === true,
  }},[_vm._l((_vm.loginButtons),function(loginButton){return [_c(_vm.getLoginButtonComponent(loginButton),{key:loginButton.redirect_url,tag:"component",attrs:{"redirect-url":_vm.addOriginalParamToUrl(loginButton.redirect_url),"name":loginButton.name,"icon":_vm.getLoginButtonIcon(loginButton),"small":_vm.showSmallLoginButtons,"invitation":_vm.invitation}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }